import React, { useEffect, useState } from 'react';

const NumberInput = ({ handleInputChange, dados }) => {
    const [inputValue, setInputValue] = useState('R$');

    useEffect(() => {
        if (dados.valor) setInputValue(dados.valor);
    }, [dados.valor]);

    const formatValue = (value) => {
        const cleanedValue = value.replace(/[^\d]/g, '');
        const numberValue = parseFloat(cleanedValue) / 10000; 
        return isNaN(numberValue) ? '' : numberValue.toLocaleString('pt-BR', {
            style: 'decimal',
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
        });
    };

    const handleChange = (e) => {
        const rawValue = e.target.value.replace(/\./g, '').replace(',', '.');
        const formattedValue = formatValue(rawValue); 
        setInputValue(formattedValue); 
        handleInputChange({ ...e, target: { ...e.target, value: formattedValue, name: dados.name } }, dados.index);
    };

    return (
        <div className='relative w-full'>
            <label 
                className={`block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 ${dados.visible ? 'hidden' : ''}`}
            >
                {dados.titulo}
            </label>
            <input
                value={inputValue}
                name={dados.name}
                onChange={handleChange}
                disabled={dados.disabled ? dados.disabled : false}
                placeholder={dados.placeholder ? dados.placeholder : ''}
                className={`w-full px-4 py-3 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-xl text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-vox-green-500 focus:border-transparent transition-all duration-200 ${dados.visible ? 'hidden' : ''}`}
                type="number"
            />
        </div>
    );
};

export default NumberInput;
